module.exports = __webpack_public_path__ + "components/hindcast-prompt/static/icon__arrow-head-f1d4e8d6f43ee85e5827624a85eb79db.svg";